export default __webpack_public_path__ + "static/media/rambo_02-1.edeb59ca.png";